// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i77-","question":"styles_question__dD7hK","inputVisibleButton":"styles_inputVisibleButton__1BnG2","note":"styles_note__3qmso"};